// Display a complete financial amount on one line, fitting actual font metrics to the available width.
import { useLayoutEffect, useRef } from 'react';
import { cn } from '@/lib/utils';

export function FitAmount({ value, className, 'data-testid': testId }: { value: string; className?: string; 'data-testid'?: string }) {
  const container = useRef<HTMLParagraphElement>(null);
  const text = useRef<HTMLSpanElement>(null);
  useLayoutEffect(() => {
    const box = container.current;
    const label = text.current;
    if (!box || !label) return;
    let active = true;
    const fit = () => {
      if (!active || !box.clientWidth) return;
      label.style.fontSize = '100%';
      const naturalWidth = label.getBoundingClientRect().width;
      if (naturalWidth > box.clientWidth) label.style.fontSize = `${(box.clientWidth - 1) / naturalWidth * 100}%`;
    };
    fit();
    let previousWidth = box.clientWidth;
    const observer = new ResizeObserver(() => {
      if (box.clientWidth !== previousWidth) { previousWidth = box.clientWidth; fit(); }
    });
    observer.observe(box);
    void document.fonts.ready.then(fit);
    document.fonts.addEventListener('loadingdone', fit);
    window.addEventListener('resize', fit);
    return () => {
      active = false;
      observer.disconnect();
      document.fonts.removeEventListener('loadingdone', fit);
      window.removeEventListener('resize', fit);
    };
  }, [value]);
  return <p ref={container} data-testid={testId} className={cn(className, 'min-w-0 whitespace-nowrap leading-tight tabular-nums')}><span ref={text} className="inline-block">{value}</span></p>;
}
